export class LogItemHelper {

    static formatArray(str: string[]): string {
        let representation = '';
        for (const col of str) {
            representation += col + ', ';
        }
        representation = representation.substring(0, representation.length - 2);
        return (representation === '') ? '(leer)' : representation;
    }

}
